import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useOutletContext, useParams } from "react-router-dom";

const Campaign = () => {
    const [campaign, setCampaign] = useState([]);
    let { id } = useParams();
    const { jwtToken } = useOutletContext();

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);
        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/campaigns/${id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setCampaign(data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [id]);

    return (
        <div>
            <h1>Кампания {campaign.townOrRegionName}</h1>

            <table className="table table-stripped table-hover">
                <tbody>
                    <tr>
                        <td>ID</td>
                        <td>{campaign.id}</td>
                    </tr>
                    {campaign.typeName && (
                        <tr>
                            <td>Тип кампании</td>
                            <td>{campaign.typeName}</td>
                        </tr>
                    )}
                    {campaign.buyer && (
                        <tr>
                            <td>Покупатель</td>
                            <td>
                                <Link to={`/users/${campaign.buyer.id}`}>
                                    {campaign.buyer.name}
                                </Link>
                                <br />
                                {campaign.buyer.email}
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td>Регион/Город:</td>
                        <td>{campaign.townOrRegionName}</td>
                    </tr>
                    <tr>
                        <td>Статус:</td>
                        <td>{campaign.activeStatus}</td>
                    </tr>
                    <tr>
                        <td>Время:</td>
                        <td>
                            {campaign.timeFrom} - {campaign.timeTo}
                        </td>
                    </tr>
                    <tr>
                        <td>Дни:</td>
                        <td>{campaign.days}</td>
                    </tr>
                    <tr>
                        <td>Цена:</td>
                        <td>{campaign.price / 100}</td>
                    </tr>
                    <tr>
                        <td>Дневной лимит:</td>
                        <td>{campaign.leadsDayLimit}</td>
                    </tr>
                    <tr>
                        <td>Баланс:</td>
                        <td>{campaign.balance / 100}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Campaign;
